import PropTypes from 'prop-types';

import { Divider } from '@mui/material';
import { LabelField } from '../../../../atoms/labels';
import AvatarMenuItem from './AvatarMenuItem';

import useIsMountedRef from '../../../../../hooks/useIsMountedRef';
import useAuth from '../../../../../hooks/useAuth';
import { useSelector } from '../../../../../redux/store';
import { PATH_PAGE } from '../../../../../routes/paths';
import socket from '../../../../../utils/socket';
import { call, formatPhone } from '../../../../../utils/formatPhone';
import { clearOnTimeLoginFlags, isOnTimeUserLogin } from '../../../../../utils/sessionFlags';

const AvatarMenuItems = ({ handleClose }) => {
  const isMountedRef = useIsMountedRef();
  const {
    logout,
    env,
    env: { settingsMobile },
    hasClientRole,
    isPartner,
    isResource,
    isMultiClient,
    user
  } = useAuth();
  const { isApp } = window.env;
  const { contractWithAvailabilityAccess } = useSelector((state) => state.resources);
  const { unseenClientFiles, unseenCompanyFiles, unseenPartnerFiles } = useSelector((state) => state.files);
  const {
    about,
    client: { myDocuments },
    manager_partner: { partners, myCompany: partnerCompany, partnerDemands },
    resource: { availabilities },
    settings
  } = PATH_PAGE;
  const { settings: envSettings } = env;
  const resAccessAvailabilities = envSettings?.res_access_availabilities ?? false;
  const partAccessDemands = envSettings?.partner_access_demands ?? false;
  const partAccessCompany = envSettings?.partner_access_company ?? false;
  const partAccessPartners = envSettings?.partner_access_partners ?? false;
  const emergencyNumber = settingsMobile?.phone_urgency;

  const handleLogout = () => {
    if (isMountedRef.current) {
      handleClose();
    }
    if (isOnTimeUserLogin() || (window.env.isClockingApp && hasClientRole)) {
      clearOnTimeLoginFlags();
      socket.logout();
      window.location.href = `${window.env.PUBLIC_URL}/pointages`;
      return;
    }
    logout();
  };


  return (
    <>
      {isApp && isResource && emergencyNumber && (
        <>
          <Divider />
          <LabelField
            id="site-phone-urgency"
            label="Num. urgence"
            noWrap
            sx={styleEmergencyNumber}
            data={formatPhone(emergencyNumber)}
            href={`tel:${call(emergencyNumber)}`}
          />
        </>
      )}

      {isPartner && (
        <>
          <Divider />
          {!!partAccessDemands && !user?.forbiddenPages?.includes('PART_DEMANDES') && (
            <AvatarMenuItem to={partnerDemands} icon="forum" text="Mes demandes" onClick={handleClose} />
          )}
          {!!partAccessCompany && !user?.forbiddenPages?.includes('PART_SOCIETE') && (
            <AvatarMenuItem
              to={`${partnerCompany}?companyId=${user.userPartnerCompanyId}`}
              icon="domain"
              text="Ma société"
              onClick={handleClose}
              badgeContent={unseenCompanyFiles}
            />
          )}
          {!!partAccessPartners && !user?.forbiddenPages?.includes('PART_PARTENAIRE') && (
            <AvatarMenuItem
              to={partners}
              icon="handshake"
              text="Mes partenaires"
              onClick={handleClose}
              badgeContent={unseenPartnerFiles}
            />
          )}
        </>
      )}

      {hasClientRole && (
        <>
          <Divider />
          <AvatarMenuItem
            to={
              isMultiClient
                ? `${myDocuments}?targetType=multi_client`
                : `${myDocuments}?targetType=client&targetId=${user.userClientId}`
            }
            icon="folder"
            text="Mes documents"
            onClick={handleClose}
            badgeContent={unseenClientFiles}
          />
        </>
      )}

      <Divider />

      <AvatarMenuItem to={settings.root} icon="settings" text="Paramètres" onClick={handleClose} />

      {!!resAccessAvailabilities && !!contractWithAvailabilityAccess.length && (
        <AvatarMenuItem to={availabilities} icon="event_available" text="Mes disponibilités" onClick={handleClose} />
      )}

      <AvatarMenuItem to={about} icon="info" text="À propos" onClick={handleClose} />

      <Divider />

      <AvatarMenuItem icon="logout" text="Se déconnecter" onClick={handleLogout} id="nav-logout" />
    </>
  );
};

const styleEmergencyNumber = {
  span: { flexGrow: 1 },
  a: { whiteSpace: 'nowrap' },
  my: 1.5,
  px: 2.5
};

AvatarMenuItems.propTypes = {
  handleClose: PropTypes.func.isRequired
};

export default AvatarMenuItems;
